import { render, staticRenderFns } from "./ModelHeader.vue?vue&type=template&id=d3256290&scoped=true"
import script from "./ModelHeader.vue?vue&type=script&lang=js"
export * from "./ModelHeader.vue?vue&type=script&lang=js"
import style0 from "./ModelHeader.vue?vue&type=style&index=0&id=d3256290&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3256290",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d3256290')) {
      api.createRecord('d3256290', component.options)
    } else {
      api.reload('d3256290', component.options)
    }
    module.hot.accept("./ModelHeader.vue?vue&type=template&id=d3256290&scoped=true", function () {
      api.rerender('d3256290', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/utils/ModelHeader.vue"
export default component.exports